export interface IPhoneMask {
    countryCode: string;
    prefix: string;
    mask: string;
}

const phoneMasksCodelist: Array<IPhoneMask> = [
    {
        countryCode: 'CZ',
        prefix: '+420',
        mask: '999 999 999',
    },
    {
        countryCode: 'SK',
        prefix: '+421',
        mask: '999 999 999',
    },
    {
        countryCode: 'DE',
        prefix: '+49',
        mask: '999 999 9999?',
    },
    {
        countryCode: 'EN',
        prefix: '+44',
        mask: '999 999 9999?',
    },
    {
        countryCode: 'RU',
        prefix: '+7',
        mask: '999 999 99',
    },
    {
        countryCode: 'UA',
        prefix: '+380',
        mask: '999 99 99',
    },
];

export default phoneMasksCodelist;
